import React from "react";
import styles from "./header.module.css";

const Header = ({ lang, toggleLang }) => {
  return (
    <header id={styles.Header}>
      <div className={styles.pivContainer}>
        <div className={styles.piv}>
          <a className={styles.logo} href={`/${lang}`}>
            <img src="/media/signature-PIV.svg" />
          </a>
          <div className={`${styles.isq} ${styles.visibleDesktop}`}>
            <a href={`/${lang}`}>Institut de la statistique du Québec</a>
          </div>
          <div className={styles.containerLiens}>
            <ul className={styles.liensPiv}>
              <li>
                <a
                  href="#"
                  role="button"
                  onClick={(evt) => {
                    evt.preventDefault();
                    toggleLang();
                  }}
                >
                  {lang === "en" ? "Français" : "English"}
                </a>
              </li>
              <li>
                <a
                  href={`/${lang}/institut/${
                    lang === "en" ? "contact-us" : "nous-joindre"
                  }`}
                >
                  {lang === "en" ? "Contact us" : "Nous joindre"}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${styles.isq} ${styles.invisibleDesktop}`}>
        <a href={`/${lang}`}>Institut de la statistique du Québec</a>
      </div>
    </header>
  );
};
export default Header;
